import type { LucideIcon } from "lucide-react";

import { cn } from "~/lib/utils";

export function AutomationRunLocationChoice(props: {
  readonly active: boolean;
  readonly description: string;
  readonly disabled: boolean;
  readonly icon: LucideIcon;
  readonly label: string;
  readonly onClick: () => void;
}) {
  const Icon = props.icon;
  return (
    <button
      className={cn(
        "min-h-touch rounded-md border px-3 py-2.5 text-left outline-none transition-colors focus-visible:ring-2 focus-visible:ring-ring",
        props.active ? "border-foreground/35 bg-accent/55" : "border-border hover:bg-accent/35",
        props.disabled ? "cursor-default" : null,
      )}
      disabled={props.disabled}
      type="button"
      onClick={props.onClick}
    >
      <span className="flex items-center gap-2 text-sm font-medium">
        <Icon className="size-4" />
        {props.label}
      </span>
      <span className="mt-1 block text-sm leading-5 text-muted-foreground md:text-xs">
        {props.description}
      </span>
    </button>
  );
}
